import {IEnvironment} from '../app/application/constants'

export const environment: IEnvironment = {
  production: false,
  apiUrl: 'https://api-vambie-be-test.vambie.net/api',
  bankIdGatewayUrl: 'https://api-vmb-bankid-gw-test.vambie.net/service',
  swishUrl: 'https://api-vmb-swish-test.vambie.net/swish',
  audience: 'app.vambie.net'
}